import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=2060ebb7&scoped=true&"
import script from "./recruit.vue?vue&type=script&lang=ts&"
export * from "./recruit.vue?vue&type=script&lang=ts&"
import style0 from "./recruit.vue?vue&type=style&index=0&id=2060ebb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060ebb7",
  null
  
)

component.options.__file = "recruit.vue"
export default component.exports